import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import Footer from './components/footer/Footer';
import Details from './components/details/Details';
import Contact from './components/contact/Contact';
import Updates from './components/updates/Updates';
// import PreviewDebugger from './components/preview-debugger/PreviewDebugger';
// import CrossDomainPreview from './components/preview-debugger/CrossDomainPreview';
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from 'react';
import { fetchAuth } from './utils/auth';
import "./App.css";
import MetaTagsManager from './components/meta-tags-manager/MetaTagsManager';


const updateStaticMetaTags = (route) => {
  // Extract route information
  const isDetailsPage = route.pathname.startsWith('/details/');
  const slug = isDetailsPage ? route.pathname.split('/details/')[1] : null;
  
  // Get the base domain for API
  const apiUrl = process.env.REACT_APP_API_URL;
  
  // Set different meta tags based on route
  if (isDetailsPage && slug) {
    // Get song ID from slug if possible
    let songId = slug;
    // console.log(`APP.js Updating meta tags for details page with slug: ${slug}`);
    if (slug.includes('-')) {
      const parts = slug.split('-');
      const lastPart = parts[parts.length - 1];

      // console.log(`Extracted last part from slug: ${lastPart}`);
      if (/^\d+$/.test(lastPart)) {
        songId = lastPart;
      }
    }
    
    // Use public-preview for static meta tags for details pages
    document.querySelector('meta[property="og:title"]').setAttribute('content', `Distorise Music - ${slug.replace(/-/g, ' ')}`);
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Listen to this track on Distorise Music Blog');
    document.querySelector('meta[property="og:image"]').setAttribute('content', `${apiUrl}/public-preview/${songId}.jpg?v=${Date.now()}`);
    document.querySelector('meta[property="og:type"]').setAttribute('content', 'music.song');
  } else {
    // Default meta tags for home and other pages
    document.querySelector('meta[property="og:title"]').setAttribute('content', 'Distorise Music Blog');
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Discover and enjoy unique music tracks on Distorise Music Blog');
    document.querySelector('meta[property="og:image"]').setAttribute('content', `${apiUrl}/default-preview.jpg?v=${Date.now()}`);
    document.querySelector('meta[property="og:type"]').setAttribute('content', 'website');
  }
  
  // Add url meta tag
  document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
}


const App = () => {
    const [page, setPage] = useState("")
    const [token, setToken] = useState(null)
    const location = useLocation();

    const sendPage = (page) => {
      // console.log("APP page " + page)
      setPage(page);
    }

    // const fetchAuth = async () => {
    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_API_URL}/options/`,
    //             { 'name': process.env.REACT_APP_USER },
    //             {withCredentials: true}
    //         );
            
    //         // const token = response.data;

    //         setToken(token);
    //         localStorage.setItem("token", response.data);
            
    //         // Set up axios interceptor for all requests
    //         axios.interceptors.request.use((config) => {
    //             if (token) {
    //                 config.headers.Authorization = `Bearer ${token}`;
    //             }
    //             return config;
    //         });
    //     } catch (err) {
    //         console.error('Authentication failed:', err);
    //     }
    // }

    useEffect(() => {
      // Update meta tags on route change - this runs BEFORE component renders
      updateStaticMetaTags(location);
    }, [location.pathname]);

    useLayoutEffect(() => {

        // Fetch new token if none exists
        if (!token) {
            fetchAuth();
        }

        setToken(localStorage.getItem("token"))

        return () => {
            // Cleanup interceptor if needed
        };
    }, [])

    return (
      <>
      <Navbar page={page} />        
        <MetaTagsManager />
        <Routes>
         
          {/* <Route path="/cross-domain-preview" element={<CrossDomainPreview />} /> */}
          {/* <Route path="/preview-debug" element={<PreviewDebugger />} /> */}
          <Route path="/" element={<Home sendPage={sendPage} />} />
          <Route path="/details/:slug" element={<Details sendPage={sendPage} />} />
          <Route path="/contact/" element={<Contact sendPage={sendPage} />} />
          <Route path="/updates/" element={<Updates sendPage={sendPage} />} />          
        </Routes>           
      <Footer />
      </>
    );
}

export default App;
